const SCRIPT_PATTERN = /<script[^>]*>[\s\S]*?<\/script>/gi;
const TAG_PATTERN = /<[^>]+>/g;

export const MAX_INTEREST_ITEM_NAME = 255;
export const MAX_INTEREST_DESCRIPTION = 2000;
export const MAX_PREFERENCE_TEXT = 2000;

const ARABIC_INDIC_DIGITS = '٠١٢٣٤٥٦٧٨٩';
const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹';

function mapOtpDigitChar(ch) {
  const arabic = ARABIC_INDIC_DIGITS.indexOf(ch);
  if (arabic >= 0) return String(arabic);
  const persian = PERSIAN_DIGITS.indexOf(ch);
  if (persian >= 0) return String(persian);
  if (ch >= '0' && ch <= '9') return ch;
  return '';
}

/** Map Eastern/Persian digits to ASCII 0-9 for OTP and numeric fields. */
export function sanitizeOtpInput(value, maxLength = 6) {
  const raw = value == null ? '' : String(value);
  let next = '';
  for (const ch of raw) {
    const digit = mapOtpDigitChar(ch);
    if (digit) next += digit;
    if (next.length >= maxLength) break;
  }
  return next;
}

function otpDigitGroups(value) {
  const raw = value == null ? '' : String(value);
  const mapped = [];
  for (const ch of raw) {
    mapped.push(mapOtpDigitChar(ch) || ' ');
  }
  return mapped.join('').split(/\s+/).filter(Boolean);
}

/**
 * Prefer a standalone 6-digit group so pasting a whole WhatsApp message
 * (often starting with a phone number) still finds the code.
 * Does not take the prefix of a longer number (a pasted phone).
 */
export function extractOtpFromPastedText(value, maxLength = 6) {
  const groups = otpDigitGroups(value);
  const exact = groups.filter((group) => group.length === maxLength);
  if (exact.length) return exact[exact.length - 1];
  const concatenated = groups.join('');
  if (concatenated.length <= maxLength) return concatenated;
  return '';
}

/** Keep price/measure fields typable on Arabic keyboards (Eastern digits, comma decimals). */
export function sanitizeDecimalInput(value) {
  const raw = value == null ? '' : String(value);
  let next = '';
  for (const ch of raw) {
    const arabic = ARABIC_INDIC_DIGITS.indexOf(ch);
    if (arabic >= 0) {
      next += String(arabic);
      continue;
    }
    const persian = PERSIAN_DIGITS.indexOf(ch);
    if (persian >= 0) {
      next += String(persian);
      continue;
    }
    if (ch === '٫') {
      next += '.';
      continue;
    }
    if (ch === ',' || ch === '٬' || ch === ' ') {
      continue;
    }
    if ((ch >= '0' && ch <= '9') || ch === '.') {
      next += ch;
    }
  }
  const dot = next.indexOf('.');
  if (dot === -1) {
    return next;
  }
  return next.slice(0, dot + 1) + next.slice(dot + 1).replace(/\./g, '');
}

export function sanitizeUserText(value, maxLength = MAX_PREFERENCE_TEXT) {
  if (value == null) return '';
  let text = String(value);
  text = text.replace(/\0/g, '');
  text = text.replace(SCRIPT_PATTERN, '');
  text = text.replace(/javascript:/gi, '');
  text = text.replace(/on\w+\s*=/gi, '');
  text = text.replace(TAG_PATTERN, '');
  text = text.replace(/\s+/g, ' ').trim();
  if (text.length > maxLength) {
    text = text.slice(0, maxLength);
  }
  return text;
}
